import { useCallback, useState } from "react";

/**
 * Owns the small overlay-UI flags driven from `AppInner`: command
 * palette, list-create, list-item-create, keyboard shortcuts,
 * membership-lost dialog, and preselect cursors.
 *
 * No cross-cutting effects — purely UI state, kept together so the
 * parent doesn't need a dozen `useState` lines for unrelated dialogs.
 */
export function useDialogState() {
  const [membershipLostWorkspace, setMembershipLostWorkspace] = useState<
    string | null
  >(null);
  const [showListItemCreate, setShowListItemCreate] = useState(false);
  const [listItemCreatePreselect, setListItemCreatePreselect] = useState<
    string | undefined
  >(undefined);
  const [showListCreate, setShowListCreate] = useState(false);
  const [showCommandPalette, setShowCommandPalette] = useState(false);
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);

  const handleOpenWorkspaceSettings = useCallback(() => {
    window.dispatchEvent(new CustomEvent("ano:open-workspace-settings"));
  }, []);

  return {
    membershipLostWorkspace,
    setMembershipLostWorkspace,
    showListItemCreate,
    setShowListItemCreate,
    listItemCreatePreselect,
    setListItemCreatePreselect,
    showListCreate,
    setShowListCreate,
    showCommandPalette,
    setShowCommandPalette,
    showKeyboardShortcuts,
    setShowKeyboardShortcuts,
    handleOpenWorkspaceSettings,
  };
}
